module.exports = __webpack_public_path__ + "static/media/shift_twitter.df6767d7.png";